import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasDealerContext } from 'utils/hasDealerContext';

export type LaunchSettingsConfigurationBreadcrumb = {
  label: string;
  link?: string;
  isActive?: boolean;
};

export const useLaunchSettingsConfigurationPage = () => {
  const location = useLocation();
  const selectedDealer = useSelector(selectDealerSelected);

  const breadcrumbsList = useMemo((): LaunchSettingsConfigurationBreadcrumb[] => {
    const fromState = (
      location.state as {
        breadcrumbsList?: LaunchSettingsConfigurationBreadcrumb[];
      } | null
    )?.breadcrumbsList;
    if (fromState?.length) {
      return fromState;
    }
    return [{ label: 'Launch settings', isActive: true }];
  }, [location.state]);

  const hasDealer = hasDealerContext(selectedDealer);
  const dealerObj =
    typeof selectedDealer === 'object' && selectedDealer !== null
      ? (selectedDealer as { site_title?: string; dealer?: string; _id?: string })
      : null;
  const dealerTitle = dealerObj?.site_title;
  const dealerId = dealerObj?.dealer || dealerObj?._id;

  return {
    breadcrumbsList,
    hasDealer,
    dealerTitle,
    dealerId,
  };
};
